import { translate } from '../i18n/LocaleProvider';
import {
  CANCELLATION_PENALTY_TYPES,
  CANCELLATION_CHARGE_TYPES,
} from '../constants';
import theme from '../theming/theme';

export const colorMap = penalty_type => {
  switch (penalty_type) {
    case CANCELLATION_PENALTY_TYPES.NONE:
      return theme.colors.tertiaryGreenDarker;
    case CANCELLATION_PENALTY_TYPES.PARTIAL:
      return theme.colors.tertiaryYellow;
    case CANCELLATION_PENALTY_TYPES.FULL:
      return theme.colors.primary;
    default:
      break;
  }
};

export const getTimelineDescription = item => {
  const { charge_type: chargeType, penalty_type: penaltyType } = item;
  let partialContent;
  if (!chargeType || !penaltyType) return partialContent;
  if (penaltyType !== CANCELLATION_PENALTY_TYPES.PARTIAL) {
    return partialContent;
  }
  const percentIsRefunded = 100 - parseInt(item.percent);
  switch (chargeType) {
    case CANCELLATION_CHARGE_TYPES.AMOUNT_TYPE:
      partialContent = translate(
        `cancellationPolicy.cancellationFund.${chargeType}.${penaltyType}`,
        { amount: `${item.currency} ${item.amount}` }
      );
      break;

    case CANCELLATION_CHARGE_TYPES.PERCENT_TYPE:
      partialContent = translate(
        `cancellationPolicy.cancellationFund.${chargeType}.${penaltyType}`,
        { percent: `${percentIsRefunded}%` }
      );
      break;
    case CANCELLATION_CHARGE_TYPES.NIGHTS_TYPE:
      partialContent = translate(
        `cancellationPolicy.cancellationFund.${chargeType}.${penaltyType}`,
        { smart_count: item.nights }
      );
      break;

    default:
      break;
  }
  return partialContent;
};
